<template>
    <div class="col-xl-3 col-md-6 col-lg-4">
        <div class="card activity-review">
            <div class="card-header pb-0">
                <h3> Activity </h3>
            </div>
            <div class="card-body">
                <div class="table-responsive theme-scrollbar">
                    <table class="table table-bordernone">
                        <tbody>
                            <tr v-for="item in data" :key="item">
                                <td>
                                    <div class="d-flex"> <img class="img-fluid" :src="getImageUrl(item.img)" alt="">
                                        <div class="flex-grow-1"><router-link to="/app/todo">
                                                <h5>{{ item.title }}</h5>
                                            </router-link>
                                            <p>{{ item.date }}</p>
                                        </div>
                                        <div class="time-badge">
                                            <p>{{ item.time }} </p>
                                        </div>
                                    </div>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import getImage from "@/mixins/getImage"
export default {
    name: 'activitPage',
    mixins: [getImage],
    data() {
        return {
            data: [{ img: "dashboard/activity/1.jpg", title: "Review request jim Smith", date: "jan 03 19 12:25 PM at Tame", time: "14m Ago" }, { img: "dashboard/activity/2.jpg", title: "New contact added", date: "jan 02 19 03:10 PM at Fresno", time: "22m Ago" }, { img: "dashboard/activity/1.jpg", title: "Sent review (504)236-7302", date: "Sent review (504)236-7302", time: "30m Ago" }]
        }
    }
}
</script>